<template>
    <div class="goods-wrap" v-loading="loading">
        <div class="goods-wrap_bg1">
            <img src="../../assets/img/goods-bg.png" alt="">
        </div>
        <div class="goods-wrap_box">
            <h3 class="goods-wrap_title">{{VUEX_USER_INFO.school_name || ''}}校服订购</h3>
            <div class="news-wrap_nav">
                <ul>
                    <li :class="{'li-active':item.id == params.channel_id}" v-for="(item,index) in goodsTypeList" :key="index" @click="selectTypeFun(item)">{{item.title}}</li>
                </ul>
            </div>
            <div class="news-list">
                <div class="news-item" :class="{'u-m-r-50':(index+1) % 3 != 0}" v-for="(item,index) in list" :key="index" @click="$router.push(`/goodsDetail?id=${item.inventoryId}`)">
                    <div class="news-item_img">
                        <img :src="item.img" alt="">
                    </div>
                    <p class="u-p-t-20 u-line-1">{{item.title}}</p>
                    <div class="u-flex u-row-between u-p-t-10">
                        <span class="news-item-font1">￥{{item.price_sale}}</span>
                        <span class="news-item-font2">库存：{{item.kucun}}</span>
                    </div>
                </div>
            </div>
            <div class="u-flex u-row-center u-m-t-30 u-m-b-80" v-if="list.length == 0">
                <el-empty description="暂无数据"></el-empty>
            </div>
            <div class="goods-page" v-if="count > 0">
                <el-pagination
                  background
                  layout="prev, pager, next,total,jumper"
                  @current-change="currentChangeFun"
                  :page-size="params.pagenum"
                  :total="count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapState,
    mapMutations,
    mapActions
} from 'vuex'
import NProgress from "nprogress";
import store from "@/store"
import cache from "@/utils/cache"
export default {
    data(){
        return {
            loading:true,
            goodsTypeList:[],
            params:{
                page:1,
                pagenum:15,
                channel_id:0,
                school_id:0
            },
            count:0,
            list:[]
        }
    },
    computed:{
        ...mapState([
            'VUEX_USER_INFO'
        ])
    },
    created(){
        this.getTypeListFun()
        this.$store.dispatch('vuex_get_user_info',{
            callback:(data)=>{
                this.params.school_id = data.school_id
                this.getGoodsListFun()
            }
        })
    },
    methods:{
        //获取分类
        getTypeListFun(){
            this.$http.get('product_channel',{},{cache:true}).then(res=>{
                if(res.code == 1){
                    let data = JSON.parse(JSON.stringify(res.data))
                    data.unshift({id:0,title:'全部'})
                    this.goodsTypeList = data || []
                }
            })
        },
        //获取商品列表
        getGoodsListFun(){
            this.$http.get('product_plist',this.params,{cache:true}).then(res=>{
                this.loading = false
                if(res.code == 1){
                    let data = res.data || []
                    this.list = data
                    this.count = res.count
                }
            })
        },
        //分页
        currentChangeFun(e){
            this.params.page = e
            this.getGoodsListFun()
        },
        //选择分类
        selectTypeFun(item){
            this.params.channel_id = item.id
            this.params.page = 1
            this.getGoodsListFun()
        }
    },
    beforeRouteEnter(to,from,next){
        if(store.state.VUEX_IF_LOGIN){
            if(cache.get('is_renzheng') == 'true'){
                NProgress.done()
                next()
            }else{
                next('/authentication')
            }
        }else{
            next('/login')
        }
    }
};
</script>
<style lang="scss">
.goods-wrap {
    width: 100%;
    min-width: $width;
    .goods-wrap_bg1 {
        width: 100%;
        // height: 600px;
        // background: url(../../assets/img/goods-bg1.png) no-repeat;
        // background-size: 1920px 600px;
        // background-position: center;
        img{
            width: 100%;
            height: auto;
            display: block;
        }
    }
    .goods-wrap_box {
        width: $width;
        margin: 0 auto;
        padding-top: 40px;
        .goods-wrap_title {
            font-size: 28px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 37px;
            color: #222222;
            padding-bottom: 30px;
        }
        .news-wrap_nav {
            ul {
                display: flex;
                li {
                    display: flex;
                    align-content: center;
                    cursor: pointer;
                    padding: 0 20px;
                    height: 30px;
                    border-radius: 15px;
                    font-size: 14px;
                    line-height: 30px;
                    color: #666;
                    user-select: none;
                    &:active {
                        opacity: 0.6;
                    }
                }
                .li-active {
                    background: #0073DF;
                    color: #fff;
                }
            }
        }
        .news-list{
            display: flex;
            flex-wrap: wrap;
            padding-top: 40px;
            .news-item{
                width: 380px;
                cursor: pointer;
                padding-bottom: 50px;
                .news-item_img{
                    width: 380px;
                    height: 380px;
                    img{
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                p{
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  line-height: 20px;
                  color: #222222;
                  padding-top: 20px;
                }
                .news-item-font1{
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    line-height: 20px;
                    color: #CC0000;
                }
                .news-item-font2{
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    line-height: 20px;
                    color: #666;
                }
                &:hover{
                  .news-item_img{
                      box-shadow: 0 5px 10px rgba($color: #000000, $alpha: 0.15);
                  }
                  p{
                      color: #0073DF;
                  }
                }
            }
        }

        .goods-page{
          display: flex;
          justify-content: center;
          padding-bottom: 70px;
        }
    }
}
</style>
